<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <witnesses-form @valid="setValid" :numberplate="true" />
  </layout-report-step>
</template>

<script lang="ts">
import WitnessesForm from "@/components/report/WitnessesForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import ReportImageUpload from "./ReportImageUpload.vue";

@Component({
  components: {
    LayoutReportStep,
    ReportImageUpload,
    WitnessesForm
  }
})
export default class ReportWitnessWithNumberplate extends ReportStepMixin implements IReportStep {
  header: IReportHeaderData = {
    title: "report.witness.title",
    description: "report.witness.description"
  };

  screen = ReportScreenEnum.witnessNumberplate;

  valid = false;

  get isDone() {
    return this.valid;
  }

  setValid(valid: boolean) {
    this.valid = valid;
  }
}
</script>
